// extracted by mini-css-extract-plugin
export default {"community":"Community_community__lNlsz","h2":"Community_h2__f+aSN","desc":"Community_desc__7Ub5Q","socials":"Community_socials__qRz+o","oneSocial":"Community_oneSocial__2HFd3"};